import { Injectable } from '@angular/core';
import { IQuote, ISegments } from "libraries/service/resources/airTrip/IGetAirTripQuotes";
import {
    IAirCreateBookingRequestPrice,
    IAirCreateBookingRequestSegment
} from "libraries/service/resources/model/booking/air/IAirCreateBooking";
import { IAirTotal } from "libraries/service/resources/model/search/air/IAirTotal";

@Injectable()
export class AirBookingRequesterHelperService {

    public simplifySegments(bookingSegment: ISegments):  IAirCreateBookingRequestSegment {
        let output: IAirCreateBookingRequestSegment;
        Object.keys(bookingSegment)
            .forEach((segmentKey: string): void => {
                if(!output){
                    output = {};
                }
                const journeyKey: string = bookingSegment[segmentKey].journey[0];
                output[segmentKey] = bookingSegment[segmentKey][journeyKey];
            });
        return output;
    }

    public getPrice(booking: Partial<IQuote>): IAirCreateBookingRequestPrice {
        const output: any = {};

        output.role = "Total";
        output.fareType = booking.fareType;
        const hasRetailPrice: boolean = booking.total.some((totalItem: IAirTotal): boolean => totalItem.xType === "retail");
        const value: number = booking.total.find((totalItem: IAirTotal): boolean => {
            const xType: "retail" | "cost" = hasRetailPrice ? "retail" : "cost";
            return totalItem.xType === xType;
        }).value;
        output.value = value;
        output.total = value;

        return output;
    }

}
